import { createSlice } from "@reduxjs/toolkit";

import {
  getBuildingThunk,
  createBuildingThunk,
  updateBuildingThunk,
  deleteBuildingThunk,
} from "state/action/building";

// Helper
const parseKeyFromArg = (arg) => {
  // arg berbentuk { pathname, queryParams }
  const qp = (arg?.queryParams || "").replace(/^\?/, "");
  const params = new URLSearchParams(qp);
  const propertyId = params.get("property") || "ALL";
  return `${propertyId}`;
};

// Initial state
const initialState = {
  // Get Building inisial state
  getBuilding: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  byKey: {},
  // Create Building inisial state
  createBuilding: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Building inisial state
  updateBuilding: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Building inisial state
  deleteBuilding: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  createBuildingInputBody: {
    property: "",
    name: "",
    code: "",
    yearContructed: "",
    amenities: [],
    location: "",
    description: "",
    buildingType: [],
  },
  selectedBuilding: {
    property: "",
    name: "",
    code: "",
    base_price: "",
    yearContructed: "",
    amenities: [],
    description: "",
  },
  // Building object value
  building_object_value: "",
};

export const buildingSlice = createSlice({
  name: "building",
  initialState,
  reducers: {
    setBuildingField: (state, action) => {
      const { field, value } = action.payload;
      state.createBuildingInputBody[field] = value;
    },
    setAmenities: (state, action) => {
      state.createBuildingInputBody.amenities = action.payload;
    },
    resetBuildingForm: (state) => {
      state.createBuildingInputBody = initialState.createBuildingInputBody;
    },
    setGetBuildingObjectValue: (state, action) => {
      return {
        ...state,
        building_object_value: action.payload,
      };
    },
    setCreateBuildingInputBody: (state, action) => {
      return {
        ...state,
        createBuildingInputBody: action.payload,
      };
    },
    setSelectedBuilding: (state, action) => {
      return {
        ...state,
        selectedBuilding: action.payload,
      };
    },
    // note: clear state
    setClearGetBuildingObjectValue: (state, _) => {
      return {
        ...state,
        building_object_value: "",
      };
    },
    setClearCreateBuildingInputBody: (state, _) => {
      return {
        ...state,
        createBuildingInputBody: {
          property: "",
          name: "",
          code: "",
          yearContructed: "",
          amenities: [],
          location: "",
          description: "",
          buildingType: [],
        },
      };
    },
    setClearGetBuilding: (state, _) => {
      return {
        ...state,
        getBuilding: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreateBuilding: (state, _) => {
      return {
        ...state,
        createBuilding: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateBuilding: (state, _) => {
      return {
        ...state,
        updateBuilding: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteBuilding: (state, _) => {
      return {
        ...state,
        deleteBuilding: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllBuildingState: (state, _) => {
      return {
        ...state,
        // Get Building inisial state
        getBuilding: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        byKey: {},
        // Create Building inisial state
        createBuilding: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Building inisial state
        updateBuilding: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Building inisial state
        deleteBuilding: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Building object value
        building_object_value: "",
      };
    },
    setClearBuildingsByKey: (state, action) => {
      const key = action.payload; // "propertyId"
      const clone = { ...(state.byKey || {}) };
      delete clone[key];
      return { ...state, byKey: clone };
    },
  },
  extraReducers(builder) {
    builder
      // Get Building reducer
      // .addCase(getBuildingThunk.pending, (state, _) => {
      //   return {
      //     ...state,
      //     getBuilding: {
      //       data: null,
      //       isPending: true,
      //       isFulfilled: false,
      //       isRejected: false,
      //       err: null,
      //     },
      //   };
      // })
      // .addCase(getBuildingThunk.fulfilled, (state, action) => {
      //   const next = {
      //     ...state,
      //     getBuilding: {
      //       data: action.payload,
      //       isPending: false,
      //       isFulfilled: true,
      //       isRejected: false,
      //       err: null,
      //     },
      //   };

      //   try {
      //     const key = parseKeyFromArg(action.meta?.arg);
      //     next.byKey = {
      //       ...(state.byKey || {}),
      //       [key]: action.payload,
      //     };
      //   } catch (_) {}
      //   return next;
      // })
      // .addCase(getBuildingThunk.rejected, (state, action) => {
      //   return {
      //     ...state,
      //     getBuilding: {
      //       data: null,
      //       isPending: false,
      //       isFulfilled: false,
      //       isRejected: true,
      //       err: action.error.message,
      //     },
      //   };
      // })
      .addCase(getBuildingThunk.pending, (state, action) => {
        const key = parseKeyFromArg(action.meta?.arg);
        state.byKey[key] = state.byKey[key] || {};
        state.byKey[key].loading = true;

        state.getBuilding = {
          data: null,
          isPending: true,
          isFulfilled: false,
          isRejected: false,
          err: null,
        };
      })
      .addCase(getBuildingThunk.fulfilled, (state, action) => {
        const key = parseKeyFromArg(action.meta?.arg);
        state.byKey[key] = {
          ...(action.payload || {}),
          loading: false,
          error: null,
        };

        state.getBuilding = {
          data: action.payload,
          isPending: false,
          isFulfilled: true,
          isRejected: false,
          err: null,
        };
      })
      .addCase(getBuildingThunk.rejected, (state, action) => {
        const key = parseKeyFromArg(action.meta?.arg);
        state.byKey[key] = {
          data: null,
          loading: false,
          error: action.error?.message,
        };

        state.getBuilding = {
          data: null,
          isPending: false,
          isFulfilled: false,
          isRejected: true,
          err: action.error.message,
        };
      })
      // Create Building reducer
      .addCase(createBuildingThunk.pending, (state, _) => {
        return {
          ...state,
          createBuilding: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createBuildingThunk.fulfilled, (state, action) => {
        return {
          ...state,
          createBuilding: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createBuildingThunk.rejected, (state, action) => {
        return {
          ...state,
          createBuilding: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Building reducer
      .addCase(updateBuildingThunk.pending, (state, _) => {
        return {
          ...state,
          updateBuilding: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateBuildingThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateBuilding: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateBuildingThunk.rejected, (state, action) => {
        return {
          ...state,
          updateBuilding: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const buildingAction = {
  ...buildingSlice.actions,
  getBuildingThunk,
  createBuildingThunk,
  updateBuildingThunk,
  deleteBuildingThunk,
};

export function selectBuildingObjectValue(state) {
  return state?.building?.building_object_value;
}

export function selectBuilding(state) {
  return state?.building;
}

export const selectBuildingsByProperty = (propertyId) => (state) => {
  const key = `${propertyId || "ALL"}`;
  return state?.building?.byKey?.[key]?.data?.data || [];
};

export default buildingSlice.reducer;
